import React, { useContext, useReducer, useState } from 'react';
import { Button, Image } from 'react-bootstrap';
import { Store } from '../Store';
import useAxios from '../hooks/useAxios';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        loading: false,
      };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'UPDATE_REQUEST':
      return { ...state, loadingUpdate: true };
    case 'UPDATE_SUCCESS':
      return { ...state, loadingUpdate: false };
    case 'UPDATE_FAIL':
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function OrderFirstOrderProducts(props) {
  const {
    productSelected,
    firstOrderProducts: products,
    setFirstOrderProducts: setProducts,
  } = props;
  const axios = useAxios();

  const [dispatch] = useReducer(reducer, {
    loading: true,
    error: '',
  });

  const { state } = useContext(Store);
  const { userInfo } = state;
  const [lastSelectedProduct, setLastSelectedProduct] = useState({});

  const moveUpHandler = (productId, orderOfProduct) => {
    setLastSelectedProduct(productId);
    if (orderOfProduct === 1) {
      return;
    }
    const productsOrdered = products.map((p, index) => {
      if (
        index < products.length - 1 &&
        products[index + 1]._id === productId
      ) {
        return { ...products[index + 1] };
      } else if (index < products.length && p._id === productId) {
        return { ...products[index - 1] };
      } else {
        return { ...p };
      }
    });

    setProducts(
      productsOrdered.map((p, index) => {
        return { ...p, order: index + 1 };
      })
    );
  };

  const moveDownHandler = (productId, orderOfProduct) => {
    setLastSelectedProduct(productId);
    if (products.length === orderOfProduct) {
      return;
    }

    const productsOrdered = products.map((p, index) => {
      if (index > 0 && products[index - 1]._id === productId) {
        return { ...products[index - 1] };
      } else if (index < products.length && p._id === productId) {
        return { ...products[index + 1] };
      } else {
        return { ...p };
      }
    });
    setProducts(
      productsOrdered.map((p, index) => {
        return { ...p, order: index + 1 };
      })
    );
  };

  return (
    <div>
      <table className="table">
        <tbody>
          {products.map((product) => (
            <>
              <tr>
                <td
                  className={
                    product._id === productSelected
                      ? 'bg-info rounded text-danger'
                      : product._id === lastSelectedProduct
                      ? 'bg-warning rounded text-danger'
                      : ''
                  }
                >
                  <Button
                    size="sm"
                    type="button"
                    className={'text-success border-success '}
                    variant="light"
                    onClick={() => moveUpHandler(product._id, product.order)}
                  >
                    <i className="fas fa-long-arrow-alt-up"></i>
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    size="sm"
                    type="button"
                    className={'text-danger border-danger '}
                    variant="light"
                    onClick={() => moveDownHandler(product._id, product.order)}
                  >
                    <i className="fas fa-long-arrow-alt-down"></i>
                  </Button>
                  &nbsp;&nbsp;
                  <Image
                    className="small-product-image fitContent border border-secondary"
                    src={product.image}
                    alt={product.name}
                    fluid
                    rounded
                  ></Image>
                  &nbsp;&nbsp;
                  {product.name}
                </td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}
